<template>
  <v-app>
    <template v-if="isLogin">
      <router-view></router-view>
    </template>

    <template v-else>
      <v-navigation-drawer app width="294" color="#ffffff" class="app-sidebar">
        <div class="sidebar-brand">
          <v-img src="./assets/cc.png" contain max-width="58"></v-img>
          <div>
            <strong>CRECC</strong>
            <span>Consejo Ciudadano</span>
          </div>
        </div>

        <div class="sidebar-section">Principal</div>
        <v-list nav dense class="px-5">
          <v-list-item
            v-for="link in links"
            :key="link.label"
            :to="link.url"
            active-class="nav-active"
            class="nav-item"
          >
            <v-list-item-icon>
              <v-icon>{{ link.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ link.label }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <div class="sidebar-alert">
          <v-icon color="#725bd6" small>mdi-bullhorn-outline</v-icon>
          <strong>Aviso</strong>
          <p>Recuerda guardar los cambios antes de cambiar de modulo.</p>
        </div>
      </v-navigation-drawer>

      <v-app-bar app flat height="82" color="#ffffff" class="app-header">
        <v-btn icon class="header-icon">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
        <div class="breadcrumbs">
          <span>CRECC</span>
          <v-icon small>mdi-chevron-right</v-icon>
          <strong>{{ currentPage }}</strong>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon class="header-icon">
          <v-icon>mdi-bell-outline</v-icon>
        </v-btn>
        <div class="profile-chip">
          <div class="profile-avatar">{{ initials }}</div>
          <div class="profile-text">
            <strong>{{ sessionName }}</strong>
            <span>{{ sessionRole }}</span>
          </div>
        </div>
        <v-btn icon class="header-icon" @click="cerrarSesion">
          <v-icon>mdi-logout</v-icon>
        </v-btn>
      </v-app-bar>

      <v-main class="app-main">
        <div class="daily-phrase">
          <v-icon color="#725bd6" small>mdi-star-four-points-outline</v-icon>
          <strong>La frase del dia es:</strong>
          <span>"Aprende, adapta y avanza."</span>
        </div>
        <router-view></router-view>
      </v-main>
    </template>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    links: [
      { label: 'Reprogramar citas', url: '/reprogramar', icon: 'mdi-calendar-edit' },
      { label: 'Resumen', url: '/', icon: 'mdi-view-dashboard-outline' },
      { label: 'Nuevo', url: '/nuevo', icon: 'mdi-file-plus-outline' },
      { label: 'Asignar', url: '/asignar', icon: 'mdi-account-arrow-right-outline' },
      { label: 'Llamadas', url: '/llamadas', icon: 'mdi-phone-in-talk-outline' },
      { label: 'En Espera', url: '/enEspera', icon: 'mdi-account-clock-outline' },
      { label: 'Busqueda', url: '/busqueda', icon: 'mdi-magnify' },
      { label: 'Usuarios', url: '/usuarios', icon: 'mdi-account-cog-outline' }
    ]
  }),
  computed: {
    isLogin() {
      return this.$route.path === '/login'
    },
    currentPage() {
      const match = this.links.find(link => link.url === this.$route.path)
      return match ? match.label : 'Resumen'
    },
    sessionName() {
      return this.$session.exists() ? this.$session.get('nombre') : 'Invitado'
    },
    sessionRole() {
      return this.$session.exists() && this.$session.get('esAdmin') ? 'admin' : 'terapeuta'
    },
    initials() {
      return this.sessionName
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map(part => part.charAt(0))
        .join('')
        .toUpperCase()
    }
  },
  beforeCreate: function () {
    if (!this.$session.exists() && this.$route.path !== '/login') {
      this.$router.push('/login')
    }
  },
  methods: {
    cerrarSesion() {
      sessionStorage.removeItem('creccToken')
      if (this.$session.exists()) {
        this.$session.destroy()
      }
      this.$router.push('/login')
    }
  }
}
</script>

<style>
html {
  background: #f6f7fb;
}

.app-sidebar {
  border-right: 1px solid #e7eaf2 !important;
}

.sidebar-brand {
  height: 132px;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 24px 30px;
}

.sidebar-brand strong {
  display: block;
  color: #17213a;
  font-size: 20px;
  line-height: 1.1;
}

.sidebar-brand span {
  color: #7c879a;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
}

.sidebar-section {
  color: #a0a8b8;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 1.7px;
  padding: 16px 32px 10px;
  text-transform: uppercase;
}

.nav-item {
  border-radius: 8px !important;
  color: #647083 !important;
  font-weight: 800;
  margin-bottom: 6px;
}

.nav-item .v-list-item__title {
  font-size: 14px;
  font-weight: 800;
}

.nav-active {
  background: #f0eafd !important;
  color: #6750c8 !important;
}

.nav-active .v-icon {
  color: #6750c8 !important;
}

.sidebar-alert {
  margin: 28px 20px;
  padding: 16px;
  border: 1px solid #e5def9;
  border-radius: 8px;
  background: linear-gradient(180deg, #ffffff, #fbf9ff);
}

.sidebar-alert strong {
  display: block;
  color: #725bd6;
  font-size: 12px;
  margin-top: 8px;
  text-transform: uppercase;
}

.sidebar-alert p {
  color: #687386;
  font-size: 12px;
  line-height: 1.5;
  margin: 8px 0 0;
}

.app-header {
  border-bottom: 1px solid #e7eaf2 !important;
}

.header-icon {
  background: #f5f6fb;
  border-radius: 8px;
  margin: 0 8px;
}

.breadcrumbs {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #97a0b2;
  font-size: 13px;
  font-weight: 700;
  margin-left: 12px;
}

.breadcrumbs strong {
  color: #303a4f;
}

.profile-chip {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 10px;
}

.profile-avatar {
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  border-radius: 12px;
  background: linear-gradient(135deg, #8f0f46, #725bd6);
  color: #ffffff;
  font-size: 13px;
  font-weight: 900;
}

.profile-text strong,
.profile-text span {
  display: block;
}

.profile-text strong {
  color: #20283a;
  font-size: 13px;
  max-width: 190px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.profile-text span {
  color: #8c95a7;
  font-size: 12px;
}

.app-main {
  background: #f6f7fb;
}

.daily-phrase {
  height: 48px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 38px;
  color: #687386;
  border-bottom: 1px solid #e8e4f5;
  background: #fbf9ff;
  font-size: 13px;
}

.daily-phrase strong {
  color: #725bd6;
  text-transform: uppercase;
  font-size: 11px;
  letter-spacing: 1px;
}

.v-main__wrap > .container {
  max-width: none;
  padding: 38px !important;
}

@media (max-width: 960px) {
  .profile-text,
  .breadcrumbs span {
    display: none;
  }

  .daily-phrase {
    padding: 0 20px;
  }
}
</style>
